import { readCookieRaw, readLocalCopy, writeCookie, writeLocalCopy } from 'utils/attribution/utm';

const GCLID_COOKIE = '__gclid';
const GCLID_SESSION_KEY = 'session_gclid';
const GCLID_LOCAL_KEY = 'persisted_gclid';

const readGclidFromCookie = (): string | null => readCookieRaw(GCLID_COOKIE);

// The local copy is Safari's backup for the cookie (see writeLocalCopy) and is
// only written alongside it, so it follows the same consent rule.
const writeGclidToCookie = (value: string, days = 90): void => {
  writeCookie(GCLID_COOKIE, value, days);
  writeLocalCopy(GCLID_LOCAL_KEY, value, days);
};

const restoreGclidFromLocal = (): string | null => {
  const copy = readLocalCopy<string>(GCLID_LOCAL_KEY);
  if (!copy) {
    return null;
  }

  writeCookie(GCLID_COOKIE, copy.value, copy.daysLeft);

  return copy.value;
};

const readGclidFromSession = (): string | null => {
  try {
    return sessionStorage.getItem(GCLID_SESSION_KEY);
  } catch {
    return null;
  }
};

const writeGclidToSession = (value: string): void => {
  try {
    sessionStorage.setItem(GCLID_SESSION_KEY, value);
  } catch {
    /* no-op */
  }
};

export const readGclid = (): string | null => readGclidFromCookie() || restoreGclidFromLocal() || readGclidFromSession();

export const captureGclid = ({
  isEU,
  hasConsent,
  cookieDays = 90,
}: {
  isEU: boolean;
  hasConsent: boolean;
  cookieDays?: number;
}): void => {
  const url = new URL(location.href, location.origin);
  const gclid = url.searchParams.get('gclid');

  if (!gclid) {
    return;
  }

  if (!isEU || hasConsent) {
    writeGclidToCookie(gclid, cookieDays);
  } else {
    writeGclidToSession(gclid);
  }
};

export const promoteSessionGclidToCookie = (days = 90): void => {
  const gclid = readGclidFromSession();
  if (gclid) {
    writeGclidToCookie(gclid, days);
  }
};
